/** Trackable controller
 *
 * To keep autosubmit from running unless it needs to
 *
 * <%= form_with(
 *  url: REPLACE_ME,
 *  method: :get
 *  data: {
 *    controller: "autosubmittable trackable",
 *    trackable_change_value: false,
 *  }
 * ) do |form| %>
 *
 *  <details data-action="toggle->trackable#check:!open toggle->autosubmittable#save:!open">
 *    <summary>Select Menu Title</summary>
 *    <div role="list">
 *      <label tabindex="0" role="menuitemcheckbox">
 *        <input data-trackable-target="item" type="checkbox" name="robots[]" value="hubot">Hubot
 *        <input data-trackable-target="item" type="checkbox" name="robots[]" value="bb-8">BB-8
 *      </label>
 *    </div>
 *  </details>
 *
 * <% end %>
 */
import { Controller } from "@hotwired/stimulus";

export default class TrackableController extends Controller<HTMLFormElement> {
  static targets = ["item"];
  static values = {
    change: {
      default: false,
      type: Boolean,
    },
  };

  declare changeValue: boolean;
  declare readonly hasItemTarget: boolean;
  declare readonly itemTarget: HTMLInputElement;

  declare readonly itemTargets: HTMLInputElement[];

  trackableEvents = ["input", "change"];

  change(event: Event): void {
    if (this.hasItemTarget) {
      if (
        event.target !== null &&
        this.itemTargets.includes(event.target as HTMLInputElement)
      ) {
        this.changeValue = true;
      }
    }
  }

  check(event: Event): void {
    if (!this.changeValue) {
      event.stopImmediatePropagation();
    } else {
      this.changeValue = false;
    }
  }

  connect(): void {
    this.trackableEvents.forEach((type) => {
      this.element.addEventListener(type, this.change.bind(this));
    });
  }

  disconnect(): void {
    this.trackableEvents.forEach((type) => {
      this.element.removeEventListener(type, this.change.bind(this));
    });
  }
}
